import React from "react";
import { Button } from "react-bootstrap";

import { useTranslation } from "react-i18next";

export default function DestroyButton({ handler, disabled }) {
  const {
    t,
  } = useTranslation();

  return (
    <div className="float-right">
      <Button onClick={handler} size="md" className="text-danger btn-link edit" title={t("common.actions.deleteData")} disabled={disabled}>
        <i className={disabled ? "nc-icon nc-simple-remove icon-bold fa-spin" : "nc-icon nc-simple-remove icon-bold"} />
      </Button>
    </div>
  );
}
